import { ElementNode, $applyNodeReplacement } from 'lexical';
import './scss/ColumnLayout.scss';

export class ColumnContainerNode extends ElementNode {
  __columnCount;

  static getType() {
    return 'column-container';
  }

  static clone(node) {
    return new ColumnContainerNode(node.__columnCount, node.__key);
  }

  constructor(columnCount = 2, key) {
    super(key);
    this.__columnCount = columnCount;
  }

  createDOM(config) {
    const dom = document.createElement('div');
    dom.className = 'column-container';
    dom.dataset.columnCount = this.__columnCount;
    return dom;
  }

  updateDOM(prevNode, dom) {
    if (prevNode.__columnCount !== this.__columnCount) {
      return true;
    }
    return false;
  }

  static importJSON(serializedNode) {
    const node = $createColumnContainerNode(serializedNode.columnCount);
    node.setFormat(serializedNode.format);
    node.setIndent(serializedNode.indent);
    node.setDirection(serializedNode.direction);
    return node;
  }

  exportJSON() {
    return {
      ...super.exportJSON(),
      columnCount: this.__columnCount,
      type: 'column-container',
      version: 1,
    };
  }

  getColumnCount() {
    return this.__columnCount;
  }

  canBeEmpty() {
    return false;
  }

  isInline() {
    return false;
  }
}

export function $createColumnContainerNode(columnCount = 2) {
  return $applyNodeReplacement(new ColumnContainerNode(columnCount));
}

export function $isColumnContainerNode(node) {
  return node instanceof ColumnContainerNode;
}
